import { Injectable } from '@angular/core';
import { FilterModel } from 'ag-grid-community';
import { FilterData } from 'app/models/businesses/Filters.model';
import { findIndex } from 'lodash';
import { LocalStorageService } from 'app/services/local-storage/local-storage.service';

const KEY = 'listFilters';

@Injectable({
  providedIn: 'root'
})
export class FiltersService {

  private filterObjectData: FilterData[];

  constructor(private localStorageService: LocalStorageService) {
    this.filterObjectData = JSON.parse(this.localStorageService.localStorage.getItem(KEY) || '[{}]') as FilterData[];
  }

  deletePathFilter(filter: FilterData): void {
    if(!this.filterObjectData) {
      return;
    }
    const filters = this.filterObjectData.filter((x: { path: string }) => (x.path !== filter.path));
    this.setFilters(filters);
  }

  getFiltersByPath(path: string = window.location.pathname): FilterData {
    const filterData = this.filterObjectData.find(col => col.path = path);
    return filterData || {
      path,
      filters: {} as FilterModel,
    };
  }

  /**
   *
   * @param filter
   * @returns All filters for this filter path
   */
  setPathFilters(filters: FilterData): FilterData {
    const index = findIndex(this.filterObjectData, ['path', filters.path]);

    if (index === -1) {
      this.filterObjectData.push(filters);
    } else {
      this.filterObjectData.splice(index, 1, filters);
    }

    this.setFilters(this.filterObjectData);
    return filters;
  }

  setFilters(filters: FilterData[]): FilterData[] {
    this.localStorageService.localStorage.setItem(KEY, JSON.stringify(filters));
    return filters;
  }
}
